// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Od","title":"e_Pd","wavy":"e_Qd","navLink":"e_Rd","active":"e_Sd","iconArrow":"e_Td"};